const ALLOWED_DOMAINS = [".shelfcycle.com", ".shelfcycle.net"];

/** @param {string|null} host */
function checkDomain(host) {
  return host == null ? false : ALLOWED_DOMAINS.some(d => host.endsWith(d));
}

/** @param {string} sub */
function buildDomains(sub) {
  return ALLOWED_DOMAINS.map(d => `${sub}${d}`);
}

// biome-ignore-start lint/style/noCommonJs: next.config.js loads this file with require(), outside the ESM graph
module.exports = {
  checkDomain,
  buildDomains,
};
// biome-ignore-end lint/style/noCommonJs: next.config.js loads this file with require(), outside the ESM graph
